/* eslint-disable */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CalculateIcon from "@mui/icons-material/Calculate";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import {
  getArmazonesValor,
  saveArmazonValor,
} from "../../services/ArmazonValorService";
import { getArmazon } from "../../services/ArmazonService";
import { getCacheData } from "../../services/CacheService";
import { getConfiguracion } from "../../services/ConfiguracionService";
import ValorArmazonDialog from "./ValorArmazonDialog";
import Message from "../../utils/Message";
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";
import { formatMoney } from "../../utils/utils";

const initialValoresData = {
  codigoIngresoArticulo: "",
  codigo: "",
  idArAsMarca: "",
  modelo: "",
  codigoExterno: "",
  descripcion: "",
  idArAsCategoria: "",
  idArAsMaterial: "",
  idArAsFormato: "",
  idArAsCalibre: "",
  idArAsTipo: "",
  idArAsColor: "",
  estado: "habilitado",
  desdeCostoUltimo: 0,
  hastaCostoUltimo: 0,
  fechaDesdeCostoUltimo: null,
  fechaHastaCostoUltimo: null,
  desdeCostoActual: 0,
  hastaCostoActual: 0,
  fechaDesdeCostoActual: null,
  fechaHastaCostoActual: null,
  tipo: "",
  monto: "",
  porcentaje: "",

  // creo las variables para Costo Actual
  idCostoPorcentaje: "",
  costoPorcentajeValor: 0,
  idCostoMonto: "",
  costoMontoValor: 0,
  costoValorFijarPeso: 0,
  costoValorFijarDolar: 0,
  // creo las variables para Factor de utilidad
  // contado
  tipoFactorContado: "",
  idFactorContadoPorcentaje: "",
  factorContadoPorcentajeValor: 0,
  idFactorContadoMonto: "",
  factorContadoMontoValor: 0,
  factorContadoValorFijarPeso: 0,
  // lista
  tipoFactorLista: "",
  idFactorListaPorcentaje: "",
  factorListaPorcentajeValor: 0,
  idFactorListaMonto: "",
  factorListaMontoValor: 0,
  factorListaValorFijarPeso: 0,
  // creo las variables para Precio de Venta
  // contado
  tipoPrecioVentaContado: "",
  idPrecioVentaContadoPorcentaje: "",
  precioVentaContadoPorcentajeValor: 0,
  idPrecioVentaContadoMonto: "",
  precioVentaContadoMontoValor: 0,
  precioVentaContadoValorFijarPeso: 0,
  // lista
  tipoPrecioVentaLista: "",
  idPrecioVentaListaPorcentaje: "",
  precioVentaListaPorcentajeValor: 0,
  idPrecioVentaListaMonto: "",
  precioVentaListaMontoValor: 0,
  precioVentaListaValorFijarPeso: 0,
};

const sumaRestaOptions = [
  { id: "suma", descripcion: "Suma" },
  { id: "resta", descripcion: "Resta" },
];

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const initialObject = { id: "", descripcion: "" };

const nameItemsText = "Actualización de precios de Armazones";
//
// #############################################################################
//
const ValorArmazonTable = () => {
  const [valoresData, setValoresData] = useState(initialValoresData);
  const [selectedRows, setSelectedRows] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [articulosCambiar, setArticulosCambiar] = useState([]);
  const [articuloData, setArticuloData] = useState({});
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [tipoRadioState, setTipoRadioState] = useState("");
  const [tipoFactorContadoRadioState, setTipoFactorContadoRadioState] =
    useState("");
  const [tipoFactorListaRadioState, setTipoFactorListaRadioState] =
    useState("");
  const [
    tipoPrecioVentaContadoRadioState,
    setTipoPrecioVentaContadoRadioState,
  ] = useState("");
  const [tipoPrecioVentaListaRadioState, setTipoPrecioVentaListaRadioState] =
    useState("");
  const [tabActive, setTabActive] = useState(false);
  const [tabOptionsActive, setTabOptionsActive] = useState(false);
  const [valueACCostoPorcentaje, setValueACCostoPorcentaje] =
    useState(initialObject);
  const [inputValueACCostoPorcentaje, setInputValueACCostoPorcentaje] =
    useState("");
  const [valueACCostoMonto, setvalueACCostoMonto] = useState(initialObject);
  const [inputValueACCostoMonto, setInputValueACCostoMonto] = useState("");
  const [valueACFactorContadoPorcentaje, setValueACFactorContadoPorcentaje] =
    useState(initialObject);
  const [
    inputValueACFactorContadoPorcentaje,
    setInputValueACFactorContadoPorcentaje,
  ] = useState("");
  const [valueACFactorContadoMonto, setValueACFactorContadoMonto] =
    useState(initialObject);
  const [inputValueACFactorContadoMonto, setInputValueACFactorContadoMonto] =
    useState("");
  const [valueACFactorListaPorcentaje, setValueACFactorListaPorcentaje] =
    useState(initialObject);
  const [
    inputValueACFactorListaPorcentaje,
    setInputValueACFactorListaPorcentaje,
  ] = useState("");
  const [valueACFactorListaMonto, setValueACFactorListaMonto] =
    useState(initialObject);
  const [inputValueACFactorListaMonto, setInputValueACFactorListaMonto] =
    useState("");
  const [
    valueACPrecioVentaContadoPorcentaje,
    setValueACPrecioVentaContadoPorcentaje,
  ] = useState(initialObject);
  const [
    inputValueACPrecioVentaContadoPorcentaje,
    setInputValueACPrecioVentaContadoPorcentaje,
  ] = useState("");
  const [valueACPrecioVentaContadoMonto, setValueACPrecioVentaContadoMonto] =
    useState(initialObject);
  const [
    inputValueACPrecioVentaContadoMonto,
    setInputValueACPrecioVentaContadoMonto,
  ] = useState("");
  const [
    valueACPrecioVentaListaPorcentaje,
    setValueACPrecioVentaListaPorcentaje,
  ] = useState(initialObject);
  const [
    inputValueACPrecioVentaListaPorcentaje,
    setInputValueACPrecioVentaListaPorcentaje,
  ] = useState("");
  const [valueACPrecioVentaListaMonto, setValueACPrecioVentaListaMonto] =
    useState(initialObject);
  const [
    inputValueACPrecioVentaListaMonto,
    setInputValueACPrecioVentaListaMonto,
  ] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [disabledAplicarCambios, setDisabledAplicarCambios] = useState(true);
  const [valueACArAsMaterial, setValueACArAsMaterial] = useState(initialObject);
  const [inputValueACArAsMaterial, setInputValueACArAsMaterial] = useState("");
  const [valueACArAsCategoria, setValueACArAsCategoria] =
    useState(initialObject);
  const [inputValueACArAsCategoria, setInputValueACArAsCategoria] =
    useState("");
  const [valueACArAsMarca, setValueACArAsMarca] = useState(initialObject);
  const [inputValueACArAsMarca, setInputValueACArAsMarca] = useState("");
  const [valueACArAsFormato, setValueACArAsFormato] = useState(initialObject);
  const [inputValueACArAsFormato, setInputValueACArAsFormato] = useState("");
  const [valueACArAsCalibre, setValueACArAsCalibre] = useState(initialObject);
  const [inputValueACArAsCalibre, setInputValueACArAsCalibre] = useState("");
  const [valueACArAsTipo, setValueACArAsTipo] = useState(initialObject);
  const [inputValueACArAsTipo, setInputValueACArAsTipo] = useState("");
  const [valueACAsColor, setValueACAsColor] = useState(initialObject);
  const [inputValueACAsColor, setInputValueACAsColor] = useState("");
  const [arAsMarcas, setArAsMarcas] = useState([]);
  const [arAsCategorias, setArAsCategorias] = useState([]);
  const [arAsMateriales, setArAsMateriales] = useState([]);
  const [arAsFormatos, setArAsFormatos] = useState([]);
  const [arAsCalibres, setArAsCalibres] = useState([]);
  const [arAsTipos, setArAsTipos] = useState([]);
  const [asColores, setAsColores] = useState([]);
  const [tipoBusqueda, setTipoBusqueda] = useState("ingresoArticulo");
  const [valorDolar, setValorDolar] = useState(0);

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return params.row.codigo?.toUpperCase() ?? "";
      },
    },
    {
      field: "descripcion_ar_as_marca",
      headerName: "Marca",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        return params.row.descripcion_ar_as_marca?.toUpperCase() ?? "";
      },
    },
    {
      field: "modelo",
      headerName: "Modelo",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        return params.row.modelo?.toUpperCase() ?? "";
      },
    },
    {
      field: "actual_costo",
      headerName: "Costo actual $",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.actual_costo || 0);
      },
    },
    {
      field: "valor_dolar_actual",
      headerName: "Valor U$S",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.valor_dolar_actual || 0);
      },
    },
    {
      field: "actual_costo_en_dolar",
      headerName: "Costo actual U$S",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.actual_costo_en_dolar || 0);
      },
    },
    {
      field: "fut_contado",
      headerName: "Fut Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.fut_contado || 0, 4);
      },
    },
    {
      field: "precio_venta_contado",
      headerName: "PVta Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.precio_venta_contado || 0);
      },
    },
    {
      field: "fut_lista",
      headerName: "Fut Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.fut_lista || 0, 4);
      },
    },
    {
      field: "precio_venta_lista",
      headerName: "PVta Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.precio_venta_lista || 0);
      },
    },
    // {
    //   field: "ultimo_costo",
    //   headerName: "Ult Costo $",
    //   headerAlign: "center",
    //   align: "right",
    //   flex: 1,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return formatMoney(params.row.ultimo_costo || 0);
    //   },
    // },
    // {
    //   field: "valor_dolar_ultimo",
    //   headerName: "Valor U$S",
    //   headerAlign: "center",
    //   align: "right",
    //   flex: 1,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return formatMoney(params.row.valor_dolar_ultimo || 0);
    //   },
    // },
    // {
    //   field: "ultimo_costo_en_dolar",
    //   headerName: "Ult Costo U$S",
    //   headerAlign: "center",
    //   align: "right",
    //   flex: 1,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return formatMoney(params.row.ultimo_costo_en_dolar || 0);
    //   },
    // },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title="ver">
          <IconButton
            size="small"
            aria-label="view"
            onClick={() => {
              handleClickVerArticulo(params.row);
            }}
          >
            <RemoveRedEyeOutlinedIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const handleSelectionModelChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    checkboxSelection: true,
    disableRowSelectionOnClick: false,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    rowSelectionModel: selectedRows,
    onRowSelectionModelChange: handleSelectionModelChange,
    getRowId: (row) => row.id,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    setIsDoingSomething(true);
    loadConfiguracion();
    loadArAsMarcas();
    loadArAsCategorias();
    loadArAsMateriales();
    loadArAsFormatos();
    loadArAsCalibres();
    loadArAsTipos();
    loadAsColores();
    setIsDoingSomething(false);
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (expandedAccordion !== null) {
      handleCleanAllOptions();
    }
  }, [expandedAccordion]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoPorcentaje"
    ) {
      setValueACPrecioVentaContadoMonto(initialObject);
      setInputValueACPrecioVentaContadoMonto("");
      valoresData.precioVentaContadoMontoValor = 0;
      valoresData.precioVentaContadoValorFijarPeso = 0;
    } else if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoMonto"
    ) {
      setValueACPrecioVentaContadoPorcentaje(initialObject);
      setInputValueACPrecioVentaContadoPorcentaje("");
      valoresData.precioVentaContadoPorcentajeValor = 0;
      valoresData.precioVentaContadoValorFijarPeso = 0;
    } else if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoFijarPeso"
    ) {
      setValueACPrecioVentaContadoPorcentaje(initialObject);
      setInputValueACPrecioVentaContadoPorcentaje("");
      setValueACPrecioVentaContadoMonto(initialObject);
      setInputValueACPrecioVentaContadoMonto("");
      valoresData.precioVentaContadoPorcentajeValor = 0;
      valoresData.precioVentaContadoMontoValor = 0;
      valoresData.precioVentaContadoValorFijarPeso = 0;
    }
  }, [tipoPrecioVentaContadoRadioState]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaPorcentaje") {
      setValueACPrecioVentaListaMonto(initialObject);
      setInputValueACPrecioVentaListaMonto("");
      valoresData.precioVentaListaMontoValor = 0;
      valoresData.precioVentaListaValorFijarPeso = 0;
    } else if (tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaMonto") {
      setValueACPrecioVentaListaPorcentaje(initialObject);
      setInputValueACPrecioVentaListaPorcentaje("");
      valoresData.precioVentaListaPorcentajeValor = 0;
      valoresData.precioVentaListaValorFijarPeso = 0;
    } else if (
      tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaFijarPeso"
    ) {
      setValueACPrecioVentaListaPorcentaje(initialObject);
      setInputValueACPrecioVentaListaPorcentaje("");
      setValueACPrecioVentaListaMonto(initialObject);
      setInputValueACPrecioVentaListaMonto("");
      valoresData.precioVentaListaPorcentajeValor = 0;
      valoresData.precioVentaListaMontoValor = 0;
      valoresData.precioVentaListaValorFijarPeso = 0;
    }
  }, [tipoPrecioVentaListaRadioState]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (tipoFactorContadoRadioState === "tipoFactorContadoPorcentaje") {
      setValueACFactorContadoMonto(initialObject);
      setInputValueACFactorContadoMonto("");
      valoresData.factorContadoMontoValor = 0;
      valoresData.factorContadoValorFijarPeso = 0;
    } else if (tipoFactorContadoRadioState === "tipoFactorContadoMonto") {
      setValueACFactorContadoPorcentaje(initialObject);
      setInputValueACFactorContadoPorcentaje("");
      valoresData.factorContadoPorcentajeValor = 0;
      valoresData.factorContadoValorFijarPeso = 0;
    } else if (tipoFactorContadoRadioState === "tipoFactorContadoFijarValor") {
      setValueACFactorContadoPorcentaje(initialObject);
      setInputValueACFactorContadoPorcentaje("");
      setValueACFactorContadoMonto(initialObject);
      setInputValueACFactorContadoMonto("");
      valoresData.factorContadoPorcentajeValor = 0;
      valoresData.factorContadoMontoValor = 0;
      valoresData.factorContadoValorFijarPeso = 0;
    }
  }, [tipoFactorContadoRadioState]);

  // ################################################################################
  //
  useEffect(() => {
    if (tipoFactorListaRadioState === "tipoFactorListaPorcentaje") {
      setValueACFactorListaMonto(initialObject);
      setInputValueACFactorListaMonto("");
      valoresData.factorListaMontoValor = 0;
      valoresData.factorListaValorFijarPeso = 0;
    } else if (tipoFactorListaRadioState === "tipoFactorListaMonto") {
      setValueACFactorListaPorcentaje(initialObject);
      setInputValueACFactorListaPorcentaje("");
      valoresData.factorListaPorcentajeValor = 0;
      valoresData.factorListaValorFijarPeso = 0;
    } else if (tipoFactorListaRadioState === "tipoFactorListaFijarValor") {
      setValueACFactorListaPorcentaje(initialObject);
      setInputValueACFactorListaPorcentaje("");
      setValueACFactorListaMonto(initialObject);
      setInputValueACFactorListaMonto("");
      valoresData.factorListaPorcentajeValor = 0;
      valoresData.factorListaMontoValor = 0;
      valoresData.factorListaValorFijarPeso = 0;
    }
  }, [tipoFactorListaRadioState]);
  //
  // ################################################################################
  //
  useEffect(() => {
    let _articulosCambiar = [];
    if (selectedRows.length > 0) {
      _articulosCambiar = articulos.filter((item) =>
        selectedRows.includes(item.id),
      );
    }
    setArticulosCambiar(_articulosCambiar);
  }, [selectedRows]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (valoresData.tipo !== "costo") {
      handleClearCostoOptions();
    }
  }, [valoresData.tipo]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setValoresData({
      ...valoresData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
    if (e.target.type === "radio") {
      if (e.target.name === "tipoFactorContado") {
        setTipoFactorContadoRadioState(e.target.value);
      } else if (e.target.name === "tipoFactorLista") {
        setTipoFactorListaRadioState(e.target.value);
      } else if (e.target.name === "tipoPrecioVentaContado") {
        setTipoPrecioVentaContadoRadioState(e.target.value);
      } else if (e.target.name === "tipoPrecioVentaLista") {
        setTipoPrecioVentaListaRadioState(e.target.value);
      } else {
        setTipoRadioState(e.target.value);
      }
    }
  };
  //
  // ################################################################################
  //
  const handleChangeNumber = (e) => {
    const _numero = e.target.value;
    if (/^\d*\.?\d*$/.test(_numero)) {
      setValoresData({
        ...valoresData,
        [e.target.name]: _numero,
      });
    }
  };
  //
  // ################################################################################
  //
  const handleChangeTipoBusqueda = (e) => {
    setTipoBusqueda(e.target.value);
    setValoresData({
      ...valoresData,
      codigoIngresoArticulo: "",
      codigo: "",
      idArAsMarca: "",
      modelo: "",
      codigoExterno: "",
      descripcion: "",
      idArAsCategoria: "",
      idArAsMaterial: "",
      idArAsFormato: "",
      idArAsCalibre: "",
      idArAsTipo: "",
      idArAsColor: "",
      estado: "habilitado",
      desdeCostoUltimo: 0,
      hastaCostoUltimo: 0,
      fechaDesdeCostoUltimo: null,
      fechaHastaCostoUltimo: null,
      desdeCostoActual: 0,
      hastaCostoActual: 0,
      fechaDesdeCostoActual: null,
      fechaHastaCostoActual: null,
    });
    setValueACArAsMarca(null);
    setValueACArAsCategoria(null);
    setValueACArAsMaterial(null);
    setValueACArAsFormato(null);
    setValueACArAsCalibre(null);
    setValueACArAsTipo(null);
    setValueACAsColor(null);
    setArticulos([]);
    setTabActive(false);
    setTabOptionsActive(false);
  };
  //
  // ################################################################################
  //
  const handleCleanAllOptions = () => {
    setValoresData({
      ...valoresData,
      idCostoPorcentaje: "",
      costoPorcentajeValor: 0,
      idCostoMonto: "",
      costoMontoValor: 0,
      costoValorFijarPeso: 0,
      costoValorFijarDolar: 0,
      tipoFactorContado: "",
      tipoPrecioVentaContado: "",
      tipoPrecioVentaLista: "",
      idFactorContadoPorcentaje: "",
      factorContadoPorcentajeValor: 0,
      idFactorContadoMonto: "",
      factorContadoMontoValor: 0,
      factorContadoValorFijarPeso: 0,
      tipoFactorLista: "",
      idFactorListaPorcentaje: "",
      factorListaPorcentajeValor: 0,
      idFactorListaMonto: "",
      factorListaMontoValor: 0,
      factorListaValorFijarPeso: 0,
      idPrecioVentaContadoPorcentaje: "",
      precioVentaContadoPorcentajeValor: 0,
      idPrecioVentaContadoMonto: "",
      precioVentaContadoMontoValor: 0,
      precioVentaContadoValorFijarPeso: 0,
      idPrecioVentaListaPorcentaje: "",
      precioVentaListaPorcentajeValor: 0,
      idPrecioVentaListaMonto: "",
      precioVentaListaMontoValor: 0,
      precioVentaListaValorFijarPeso: 0,
      tipo: "",
    });
    setTipoRadioState("");
    setTipoFactorContadoRadioState("");
    setTipoFactorListaRadioState("");
    setTipoPrecioVentaContadoRadioState("");
    setTipoPrecioVentaListaRadioState("");
    setValueACCostoPorcentaje(initialObject);
    setInputValueACCostoPorcentaje("");
    setvalueACCostoMonto(initialObject);
    setInputValueACCostoMonto("");
    setValueACFactorContadoPorcentaje(initialObject);
    setInputValueACFactorContadoPorcentaje("");
    setValueACFactorContadoMonto(initialObject);
    setInputValueACFactorContadoMonto("");
    setValueACFactorListaPorcentaje(initialObject);
    setInputValueACFactorListaPorcentaje("");
    setValueACFactorListaMonto(initialObject);
    setInputValueACFactorListaMonto("");
    setValueACPrecioVentaContadoPorcentaje(initialObject);
    setInputValueACPrecioVentaContadoPorcentaje("");
    setValueACPrecioVentaContadoMonto(initialObject);
    setInputValueACPrecioVentaContadoMonto("");
    setValueACPrecioVentaListaPorcentaje(initialObject);
    setInputValueACPrecioVentaListaPorcentaje("");
    setValueACPrecioVentaListaMonto(initialObject);
    setInputValueACPrecioVentaListaMonto("");
  };
  //
  // ################################################################################
  //
  const handleClearCostoOptions = () => {
    setValoresData({
      ...valoresData,
      idCostoPorcentaje: "",
      costoPorcentajeValor: 0,
      idCostoMonto: "",
      costoMontoValor: 0,
      costoValorFijarPeso: 0,
      costoValorFijarDolar: 0,
    });
    setValueACCostoPorcentaje(initialObject);
    setInputValueACCostoPorcentaje("");
    setvalueACCostoMonto(initialObject);
    setInputValueACCostoMonto("");
  };
  //
  // ################################################################################
  //
  const handleChangeFechaDesdeCostoUltimo = (fecha) => {
    setValoresData({
      ...valoresData,
      fechaDesdeCostoUltimo: fecha,
    });
  };
  // ################################################################################
  //
  const handleChangeFechaHastaCostoUltimo = (fecha) => {
    setValoresData({
      ...valoresData,
      fechaHastaCostoUltimo: fecha,
    });
  };
  // ################################################################################
  //
  const handleChangeFechaDesdeCostoActual = (fecha) => {
    setValoresData({
      ...valoresData,
      fechaDesdeCostoActual: fecha,
    });
  };
  // ################################################################################
  //
  const handleChangeFechaHastaCostoActual = (fecha) => {
    setValoresData({
      ...valoresData,
      fechaHastaCostoActual: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setTipoBusqueda("ingresoArticulo");
    setValoresData(initialValoresData);
    setValueACArAsMarca(initialObject);
    setInputValueACArAsMarca("");
    setValueACArAsCategoria(initialObject);
    setInputValueACArAsCategoria("");
    setValueACArAsMaterial(initialObject);
    setInputValueACArAsMarca("");
    setValueACArAsFormato(initialObject);
    setInputValueACArAsFormato("");
    setValueACArAsCalibre(initialObject);
    setInputValueACArAsCalibre("");
    setValueACArAsTipo(initialObject);
    setInputValueACArAsTipo("");
    setValueACAsColor(initialObject);
    setInputValueACAsColor("");
    setArticulos([]);
    setTabActive(false);
    setTabOptionsActive(false);
    setArticulosCambiar([]);
    setSelectedRows([]);
    setDisabledAplicarCambios(true);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (tipoBusqueda === "ingresoArticulo") {
      if (!valoresData.codigoIngresoArticulo) {
        setMessage({
          messageText:
            "Debes ingresar un código de Ingreso de Artículos para buscar",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    }
    load();
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {};

    if (tipoBusqueda === "ingresoArticulo") {
      _params = {
        tipo_busqueda: tipoBusqueda,
        codigo: limpiaCodigo(valoresData.codigoIngresoArticulo).toUpperCase(),
      };
    } else {
      setValoresData({
        ...valoresData,
        codigo: limpiaCodigo(valoresData.codigo).toUpperCase(),
        codigoExterno: limpiaCodigo(valoresData.codigoExterno).toUpperCase(),
      });

      _params = {
        tipo_busqueda: tipoBusqueda,
        codigo: valoresData.codigo,
        idArAsMarca: valoresData.idArAsMarca,
        modelo: valoresData.modelo,
        codigoExterno: valoresData.codigoExterno,
        descripcion: valoresData.descripcion,
        idArAsCategoria: valoresData.idArAsCategoria,
        idArAsMaterial: valoresData.idArAsMaterial,
        idArAsFormato: valoresData.idArAsFormato,
        idArAsCalibre: valoresData.idArAsCalibre,
        idArAsTipo: valoresData.idArAsTipo,
        idArAsColor: valoresData.idArAsColor,
        estado: valoresData.estado,
        desdeCostoUltimo: valoresData.desdeCostoUltimo,
        hastaCostoUltimo: valoresData.hastaCostoUltimo,
        fechaDesdeCostoUltimo: valoresData.fechaDesdeCostoUltimo,
        fechaHastaCostoUltimo: valoresData.fechaHastaCostoUltimo,
        desdeCostoActual: valoresData.desdeCostoActual,
        hastaCostoActual: valoresData.hastaCostoActual,
        fechaDesdeCostoActual: valoresData.fechaDesdeCostoActual,
        fechaHastaCostoActual: valoresData.fechaHastaCostoActual,
      };
    }

    setIsDoingSomething(true);
    const response = await getArmazonesValor(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTabActive(true);
      setTabOptionsActive(true);

      if (response.data.data.length === 0) {
        setArticulos([]);
        let _messageText = "";
        if (tipoBusqueda === "ingresoArticulo") {
          _messageText =
            "No hay Armazones en el Ingreso de Artículos ingresado";
        } else {
          _messageText =
            "No hay Armazones que coincidan con los criterios de búsqueda";
        }

        setMessage({
          messageText: _messageText,
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      let _articulos = response.data.data.map((item) => {
        return {
          ...item,
          valor_dolar_actual: valorDolar,
        };
      });
      setArticulos(_articulos);
      setTabIndex(1);
    } else {
      setTabActive(false);
      setTabOptionsActive(false);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickVerArticulo = (parArticulo) => {

    let _articulo = {};

    const loadArticulo = async () => {
      setIsDoingSomething(true);
      const response = await getArmazon({ id: parArticulo.id });
      setIsDoingSomething(false);

      if (response.ok) {

        let _response = response.data.data;
        let _colores = _response.color_list;
        let _colorArray = [];
        _colores.forEach((item) => {
          _colorArray.push(item.descripcion_ar_as_color);
        });

        _articulo = {
          id: _response.id,
          codigo: _response.codigo,
          descripcionArAsMarca: _response.descripcion_ar_as_marca,
          modelo: _response.modelo,
          descripcion: _response.descripcion,
          descripcionArAsCategoria: _response.descripcion_ar_as_categoria,
          descripcionArAsMaterial: _response.descripcion_ar_as_material,
          descripcionArAsFormato: _response.descripcion_ar_as_formato,
          descripcionArAsCalibre: _response.valor_ar_as_calibre,
          descripcionArAsTipo: _response.descripcion_ar_as_tipo,
          descripcionArAsColor: _colorArray.join(", "),
          descripcionAsColorLente: _response.descripcion_as_color_lente,
          ultimoCosto: _response.ultimo_costo,
          valorDolarUltimo: _response.valor_dolar_ultimo,
          ultimoCostoEnDolar: _response.ultimo_costo_en_dolar,
          actualCosto: _response.actual_costo,
          fechaCreacion: _response.fecha_creacion,
          fechaActualCosto: _response.fecha_actual_costo,
          fechaUltimoCosto: _response.fecha_ultimo_costo,
          valorDolarActual: _response.valor_dolar_actual,
          actualCostoEnDolar: _response.actual_costo_en_dolar,
          previoVentaContado: _response.precio_venta_contado,
          futContado: _response.fut_contado,
          futLista: _response.fut_lista,
          precioVentaLista: _response.precio_venta_lista,
          observaciones: _response.observaciones,
        };
        setArticuloData(_articulo);
        setOpenDialog(true);
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
      }
    };
    loadArticulo();
  };
  //
  // ################################################################################
  //
  const loadArAsMarcas = async () => {
    const response = await getCacheData("ar_as_marca");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsMarcas(_var);
    } else {
      setArAsMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsCategorias = async () => {
    const response = await getCacheData("ar_as_categoria");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsCategorias(_var);
    } else {
      setArAsCategorias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsFormatos = async () => {
    const response = await getCacheData("ar_as_formato");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsFormatos(_var);
    } else {
      setArAsFormatos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsCalibres = async () => {
    const response = await getCacheData("ar_as_calibre");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toString(),
        });
      });
      setArAsCalibres(_var);
    } else {
      setArAsCalibres([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsTipos = async () => {
    const response = await getCacheData("ar_as_tipo");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsTipos(_var);
    } else {
      setArAsTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadAsColores = async () => {
    const response = await getCacheData("ar_as_color");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setAsColores(_var);
    } else {
      setAsColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsMateriales = async () => {
    const response = await getCacheData("ar_as_material");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsMateriales(_var);
    } else {
      setArAsMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadConfiguracion = async () => {
    const response = await getConfiguracion();
    if (response.ok) {
      setValorDolar(response.data.data[0].valor_dolar);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  //
  // ##########################################################################
  //
  const calculaCostoActual = () => {
    let _articulosCambiar = articulosCambiar;

    if (valoresData.tipo === "tipoCostoPorcentaje") {
      const _costoPorcentajeValor = parseFloat(
        valoresData.costoPorcentajeValor,
      );

      if (_costoPorcentajeValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACCostoPorcentaje.id === "suma") {
            item.actual_costo +=
              (item.actual_costo * _costoPorcentajeValor) / 100;
          } else {
            item.actual_costo -=
              (item.actual_costo * _costoPorcentajeValor) / 100;
          }

          if (item.valor_dolar_actual > 0) {
            item.actual_costo_en_dolar =
              item.actual_costo / item.valor_dolar_actual;
          } else {
            item.actual_costo_en_dolar = 0;
          }

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_contado =
            item.actual_costo * item.fut_contado * _tasaIva;
          item.precio_venta_lista =
            item.actual_costo * item.fut_lista * _tasaIva;
        });
      }
    }

    if (valoresData.tipo === "tipoCostoMonto") {
      const _costoMontoValor = parseFloat(valoresData.costoMontoValor);

      if (_costoMontoValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACCostoMonto.id === "suma") {
            item.actual_costo += _costoMontoValor;
          } else {
            item.actual_costo -= _costoMontoValor;
          }

          if (item.valor_dolar_actual > 0) {
            item.actual_costo_en_dolar =
              item.actual_costo / item.valor_dolar_actual;
          } else {
            item.actual_costo_en_dolar = 0;
          }

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_contado =
            item.actual_costo * item.fut_contado * _tasaIva;
          item.precio_venta_lista =
            item.actual_costo * item.fut_lista * _tasaIva;
        });
      }
    }

    if (valoresData.tipo === "tipoCostoFijarPeso") {
      const _costoValorFijarPeso = parseFloat(valoresData.costoValorFijarPeso);

      _articulosCambiar.forEach((item) => {
        item.actual_costo = _costoValorFijarPeso;

        if (item.valor_dolar_actual > 0) {
          item.actual_costo_en_dolar =
            item.actual_costo / item.valor_dolar_actual;
        } else {
          item.actual_costo_en_dolar = 0;
        }

        const _tasaIva = 1 + item.tasa_iva / 100;
        item.precio_venta_contado = item.actual_costo * item.fut_contado * _tasaIva;
        item.precio_venta_lista = item.actual_costo * item.fut_lista * _tasaIva;
      });
    }

    if (valoresData.tipo === "tipoCostoFijarDolar") {
      const _costoValorFijarDolar = parseFloat(
        valoresData.costoValorFijarDolar,
      );

      _articulosCambiar.forEach((item) => {
        item.actual_costo_en_dolar = _costoValorFijarDolar;
        item.actual_costo = _costoValorFijarDolar * item.valor_dolar_actual;

        const _tasaIva = 1 + item.tasa_iva / 100;
        item.precio_venta_contado = item.actual_costo * item.fut_contado * _tasaIva;
        item.precio_venta_lista = item.actual_costo * item.fut_lista * _tasaIva;
      });
    }
  };
  //
  // ##########################################################################
  //
  const calculaFactorUtilidad = () => {
    let _articulosCambiar = articulosCambiar;

    if (tipoFactorContadoRadioState === "tipoFactorContadoPorcentaje") {
      const _factorContadoPorcentajeValor = parseFloat(
        valoresData.factorContadoPorcentajeValor,
      );

      if (_factorContadoPorcentajeValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACFactorContadoPorcentaje.id === "suma") {
            item.fut_contado +=
              (item.fut_contado * _factorContadoPorcentajeValor) / 100;
          } else {
            item.fut_contado -=
              (item.fut_contado * _factorContadoPorcentajeValor) / 100;
          }

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_contado =
            item.actual_costo * item.fut_contado * _tasaIva;
          item.cambio = true;
        });
      }
    } else if (tipoFactorContadoRadioState === "tipoFactorContadoMonto") {
      const _factorContadoMontoValor = parseFloat(
        valoresData.factorContadoMontoValor,
      );

      if (_factorContadoMontoValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACFactorContadoMonto.id === "suma") {
            item.fut_contado += _factorContadoMontoValor;
          } else {
            item.fut_contado -= _factorContadoMontoValor;
          }

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_contado =
            item.actual_costo * item.fut_contado * _tasaIva;
          item.cambio = true;
        });
      }
    } else if (tipoFactorContadoRadioState === "tipoFactorContadoFijarValor") {
      const _factorContadoValorFijarPeso = parseFloat(
        valoresData.factorContadoValorFijarPeso,
      );

      _articulosCambiar.forEach((item) => {
        item.fut_contado = _factorContadoValorFijarPeso;
        const _tasaIva = 1 + item.tasa_iva / 100;
        item.precio_venta_contado =
          item.actual_costo * item.fut_contado * _tasaIva;
      });
    }

    if (tipoFactorListaRadioState === "tipoFactorListaPorcentaje") {
      const _factorListaPorcentajeValor = parseFloat(
        valoresData.factorListaPorcentajeValor,
      );

      if (_factorListaPorcentajeValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACFactorListaPorcentaje.id === "suma") {
            item.fut_lista +=
              (item.fut_lista * _factorListaPorcentajeValor) / 100;
          } else {
            item.fut_lista -=
              (item.fut_lista * _factorListaPorcentajeValor) / 100;
          }
          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_lista =
            item.actual_costo * item.fut_lista * _tasaIva;
          item.cambio = true;
        });
      }
    } else if (tipoFactorListaRadioState === "tipoFactorListaMonto") {
      const _factorListaMontoValor = parseFloat(
        valoresData.factorListaMontoValor,
      );

      if (_factorListaMontoValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACFactorListaMonto.id === "suma") {
            item.fut_lista += _factorListaMontoValor;
          } else {
            item.fut_lista -= _factorListaMontoValor;
          }
          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_lista =
            item.actual_costo * item.fut_lista * _tasaIva;
          item.cambio = true;
        });
      }
    } else if (tipoFactorListaRadioState === "tipoFactorListaFijarValor") {
      const _factorListaValorFijarPeso = parseFloat(
        valoresData.factorListaValorFijarPeso,
      );

      _articulosCambiar.forEach((item) => {
        item.fut_lista = _factorListaValorFijarPeso;
        const _tasaIva = 1 + item.tasa_iva / 100;
        item.precio_venta_lista = item.actual_costo * item.fut_lista * _tasaIva;
      });
    }
  };
  //
  // ##########################################################################
  //
  const calculaPrecioVenta = () => {
    let _articulosCambiar = articulosCambiar;

    if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoPorcentaje"
    ) {
      const _precioVentaContadoPorcentajeValor = parseFloat(
        valoresData.precioVentaContadoPorcentajeValor,
      );

      if (_precioVentaContadoPorcentajeValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACPrecioVentaContadoPorcentaje.id === "suma") {
            item.precio_venta_contado +=
              (item.precio_venta_contado * _precioVentaContadoPorcentajeValor) /
              100;
          } else {
            item.precio_venta_contado -=
              (item.precio_venta_contado * _precioVentaContadoPorcentajeValor) /
              100;
          }

          if (item.actual_costo > 0) {
            const _tasaIva = 1 + item.tasa_iva / 100;
            item.fut_contado =
              item.precio_venta_contado / _tasaIva / item.actual_costo;
          } else {
            item.fut_contado = 0;
          }
          item.cambio = true;
        });
      }
    } else if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoMonto"
    ) {
      const _precioVentaContadoMontoValor = parseFloat(
        valoresData.precioVentaContadoMontoValor,
      );

      if (_precioVentaContadoMontoValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACPrecioVentaContadoMonto.id === "suma") {
            item.precio_venta_contado += _precioVentaContadoMontoValor;
          } else {
            item.precio_venta_contado -= _precioVentaContadoMontoValor;
          }

          if (item.actual_costo > 0) {
            const _tasaIva = 1 + item.tasa_iva / 100;
            item.fut_contado =
              item.precio_venta_contado / _tasaIva / item.actual_costo;
          } else {
            item.fut_contado = 0;
          }
          item.cambio = true;
        });
      }
    } else if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoFijarPeso"
    ) {
      const _precioVentaContadoValorFijarPeso = parseFloat(
        valoresData.precioVentaContadoValorFijarPeso,
      );

      _articulosCambiar.forEach((item) => {
        item.precio_venta_contado = _precioVentaContadoValorFijarPeso;

        if (item.actual_costo > 0) {
          const _tasaIva = 1 + item.tasa_iva / 100;
          item.fut_contado =
            item.precio_venta_contado / _tasaIva / item.actual_costo;
        } else {
          item.fut_contado = 0;
        }
        item.cambio = true;
      });
    }

    if (tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaPorcentaje") {
      const _precioVentaListaPorcentajeValor = parseFloat(
        valoresData.precioVentaListaPorcentajeValor,
      );

      if (_precioVentaListaPorcentajeValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACPrecioVentaListaPorcentaje.id === "suma") {
            item.precio_venta_lista +=
              (item.precio_venta_lista * _precioVentaListaPorcentajeValor) /
              100;
          } else {
            item.precio_venta_lista -=
              (item.precio_venta_lista * _precioVentaListaPorcentajeValor) /
              100;
          }

          if (item.actual_costo > 0) {
            const _tasaIva = 1 + item.tasa_iva / 100;
            item.fut_lista =
              item.precio_venta_lista / _tasaIva / item.actual_costo;
          } else {
            item.fut_lista = 0;
          }
          item.cambio = true;
        });
      }
    } else if (tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaMonto") {
      const _precioVentaListaMontoValor = parseFloat(
        valoresData.precioVentaListaMontoValor,
      );

      if (_precioVentaListaMontoValor > 0) {
        _articulosCambiar.forEach((item) => {
          if (valueACPrecioVentaListaMonto.id === "suma") {
            item.precio_venta_lista += _precioVentaListaMontoValor;
          } else {
            item.precio_venta_lista -= _precioVentaListaMontoValor;
          }

          if (item.actual_costo > 0) {
            const _tasaIva = 1 + item.tasa_iva / 100;
            item.fut_lista =
              item.precio_venta_lista / _tasaIva / item.actual_costo;
          } else {
            item.fut_lista = 0;
          }
          item.cambio = true;
        });
      }
    } else if (
      tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaFijarPeso"
    ) {
      const _precioVentaListaValorFijarPeso = parseFloat(
        valoresData.precioVentaListaValorFijarPeso,
      );

      _articulosCambiar.forEach((item) => {
        item.precio_venta_lista = _precioVentaListaValorFijarPeso;

        if (item.actual_costo > 0) {
          const _tasaIva = 1 + item.tasa_iva / 100;
          item.fut_lista =
            item.precio_venta_lista / _tasaIva / item.actual_costo;
        } else {
          item.fut_lista = 0;
        }
        item.cambio = true;
      });
    }
  };
  //
  // ##########################################################################
  //
  const handleCalcularCambios = () => {

    if (expandedAccordion === "costoActual") {
      calculaCostoActual();
    } else if (expandedAccordion === "factorUtilidad") {
      calculaFactorUtilidad();
    } else if (expandedAccordion === "precioVenta") {
      calculaPrecioVenta();
    }

    const _hayValoresInvalidos = hayValoresInvalidos();
    setDisabledAplicarCambios(_hayValoresInvalidos);

    if (_hayValoresInvalidos) {
      setMessage({
        messageText:
          "Los cambios aplicados generaron valores negativos o nulos",
        severity: "error",
      });
      setShowMessage(true);
    }
    setTabIndex(1);
  };
  //
  // ##########################################################################
  //
  const aplicarCambios = async () => {

    let _articulosCambiar = articulosCambiar.map((item) => ({
      id_armazon: item.id,
      actual_costo: item.actual_costo,
      valor_dolar_actual: item.valor_dolar_actual,
      fut_contado: item.fut_contado,
      precio_venta_contado: item.precio_venta_contado,
      fut_lista: item.fut_lista,
      precio_venta_lista: item.precio_venta_lista,
    }));

    setIsDoingSomething(true);
    const response = await saveArmazonValor(_articulosCambiar);
    setIsDoingSomething(false);

    if (response.ok) {
      handleLimpiar();
      setTabIndex(0);
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const hayValoresInvalidos = () => {

    const _valorInvalido = articulosCambiar.some((item) => {
      return (
        item.actual_costo <= 0 ||
        item.actual_costo_en_dolar <= 0 ||
        item.precio_venta_contado <= 0 ||
        item.precio_venta_lista <= 0
      );
    });
    return _valorInvalido;
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1}>
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box
                  sx={{ mt: 1 }}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h5" display="cristal" gutterBottom>
                    {nameItemsText}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: "success.main",
                      opacity: 0.85,
                    }}
                  >
                    Valor del dólar: $ {valorDolar}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              sx={{ mb: 3 }}
            >
              <Tab label="Buscar" size="medium" sx={{ ml: 2 }} />

              <Tab
                label="Resultado"
                size="medium"
                sx={{ ml: 1 }}
                disabled={tabActive === false}
              />

              <Tab
                label="Opciones"
                size="medium"
                sx={{ ml: 1 }}
                disabled={
                  tabOptionsActive === false || articulosCambiar.length === 0
                }
              />
            </Tabs>

            {/* tab buscar */}

            {tabIndex === 0 && (
              <>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <FormControl>
                      <RadioGroup
                        name="tipoBusqueda"
                        value={tipoBusqueda}
                        onChange={handleChangeTipoBusqueda}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            gap: 1,
                            mb: 1,
                          }}
                        >
                          <FormControlLabel
                            value="ingresoArticulo"
                            control={<Radio size="small" />}
                            label="Buscar por Ingreso de Artículos"
                            sx={{ minWidth: "120px", mr: 1 }}
                          />

                          <FormControlLabel
                            value="articulo"
                            control={<Radio size="small" />}
                            label="Buscar por atributos de Artículos"
                            sx={{ minWidth: "120px", mr: 1 }}
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="codigoIngresoArticulo"
                      label="Ingreso de Artículos"
                      variant="outlined"
                      size="small"
                      name="codigoIngresoArticulo"
                      value={valoresData.codigoIngresoArticulo}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      disabled={tipoBusqueda !== "ingresoArticulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="codigo"
                      label="Código"
                      variant="outlined"
                      size="small"
                      name="codigo"
                      value={valoresData.codigo}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-sl-marca"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACArAsMarca && valueACArAsMarca.id
                          ? valueACArAsMarca
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACArAsMarca(newValue);
                        setValoresData({
                          ...valoresData,
                          idArAsMarca: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACArAsMarca}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACArAsMarca(newInputValue);
                      }}
                      options={arAsMarcas}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Marca" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="modelo"
                      label="Modelo"
                      variant="outlined"
                      size="small"
                      name="modelo"
                      value={valoresData.modelo}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="codigoExterno"
                      label="Código Externo"
                      variant="outlined"
                      size="small"
                      name="codigoExterno"
                      value={valoresData.codigoExterno}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="descripcion"
                      label="Descripción"
                      variant="outlined"
                      size="small"
                      name="descripcion"
                      value={valoresData.descripcion}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-ar-as-categoria"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACArAsCategoria && valueACArAsCategoria.id
                          ? valueACArAsCategoria
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACArAsCategoria(newValue);
                        setValoresData({
                          ...valoresData,
                          idArAsCategoria: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACArAsCategoria}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACArAsCategoria(newInputValue);
                      }}
                      options={arAsCategorias}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Categoría" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-ar-as-material"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACArAsMaterial && valueACArAsMaterial.id
                          ? valueACArAsMaterial
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACArAsMaterial(newValue);
                        setValoresData({
                          ...valoresData,
                          idArAsMaterial: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACArAsMaterial}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACArAsMaterial(newInputValue);
                      }}
                      options={arAsMateriales}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Material" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-ar-as-formato"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACArAsFormato && valueACArAsFormato.id
                          ? valueACArAsFormato
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACArAsFormato(newValue);
                        setValoresData({
                          ...valoresData,
                          idArAsFormato: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACArAsFormato}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACArAsFormato(newInputValue);
                      }}
                      options={arAsFormatos}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Formato" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-ar-as-calibre"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACArAsCalibre && valueACArAsCalibre.id
                          ? valueACArAsCalibre
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACArAsCalibre(newValue);
                        setValoresData({
                          ...valoresData,
                          idArAsCalibre: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACArAsCalibre}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACArAsCalibre(newInputValue);
                      }}
                      options={arAsCalibres}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Calibre" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-ar-as-tipo"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACArAsTipo && valueACArAsTipo.id
                          ? valueACArAsTipo
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACArAsTipo(newValue);
                        setValoresData({
                          ...valoresData,
                          idArAsTipo: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACArAsTipo}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACArAsTipo(newInputValue);
                      }}
                      options={arAsTipos}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Tipo" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-as-color"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACAsColor && valueACAsColor.id
                          ? valueACAsColor
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACAsColor(newValue);
                        setValoresData({
                          ...valoresData,
                          idArAsColor: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACAsColor}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACAsColor(newInputValue);
                      }}
                      options={asColores}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Color" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="estado-select-label">Estado</InputLabel>
                      <Select
                        sx={{ width: "100%", mr: 1 }}
                        labelId="estado"
                        label="Estado"
                        id="estado"
                        name="estado"
                        value={valoresData.estado}
                        size="small"
                        onChange={handleChange}
                        disabled={tipoBusqueda !== "articulo"}
                      >
                        {estadoOptions.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="desdeCostoUltimo"
                      label="Costo Último Desde $"
                      variant="outlined"
                      size="small"
                      name="desdeCostoUltimo"
                      type="text"
                      value={valoresData.desdeCostoUltimo}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="hastaCostoUltimo"
                      label="Costo Último Hasta $"
                      variant="outlined"
                      size="small"
                      name="hastaCostoUltimo"
                      type="text"
                      value={valoresData.hastaCostoUltimo}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <DatePicker
                      id="fechaDesdeCostoUltimo"
                      label="Ultimo Costo Desde Fecha"
                      name="fechaDesdeCostoUltimo"
                      value={valoresData.fechaDesdeCostoUltimo}
                      format="dd/MM/yyyy"
                      maxDate={new Date()}
                      onChange={(fechaDesdeCostoUltimo) =>
                        handleChangeFechaDesdeCostoUltimo(fechaDesdeCostoUltimo)
                      }
                      slots={{ textField: TextField }}
                      slotProps={{
                        textField: {
                          size: "small",
                          variant: "outlined",
                          sx: { width: "100%" },
                        },
                      }}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <DatePicker
                      id="fechaHastaCostoUltimo"
                      label="Ultimo Costo Hasta Fecha"
                      name="fechaHastaCostoUltimo"
                      value={valoresData.fechaHastaCostoUltimo}
                      format="dd/MM/yyyy"
                      maxDate={new Date()}
                      onChange={(fechaHastaCostoUltimo) =>
                        handleChangeFechaHastaCostoUltimo(fechaHastaCostoUltimo)
                      }
                      slots={{ textField: TextField }}
                      slotProps={{
                        textField: {
                          size: "small",
                          variant: "outlined",
                          sx: { width: "100%" },
                        },
                      }}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="desdeCostoActual"
                      label="Costo Actual Desde $"
                      variant="outlined"
                      size="small"
                      name="desdeCostoActual"
                      type="text"
                      value={valoresData.desdeCostoActual}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="hastaCostoActual"
                      label="Costo Actual Hasta $"
                      variant="outlined"
                      size="small"
                      name="hastaCostoActual"
                      type="text"
                      value={valoresData.hastaCostoActual}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <DatePicker
                      id="fechaDesdeCostoActual"
                      label="Costo Actual Desde Fecha"
                      name="fechaDesdeCostoActual"
                      value={valoresData.fechaDesdeCostoActual}
                      format="dd/MM/yyyy"
                      maxDate={new Date()}
                      onChange={(fechaDesdeCostoActual) =>
                        handleChangeFechaDesdeCostoActual(fechaDesdeCostoActual)
                      }
                      slots={{ textField: TextField }}
                      slotProps={{
                        textField: {
                          size: "small",
                          variant: "outlined",
                          sx: { width: "100%" },
                        },
                      }}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <DatePicker
                      id="fechaHastaCostoActual"
                      label="Costo Actual Hasta Fecha"
                      name="fechaHastaCostoActual"
                      value={valoresData.fechaHastaCostoActual}
                      format="dd/MM/yyyy"
                      maxDate={new Date()}
                      onChange={(fechaHastaCostoActual) =>
                        handleChangeFechaHastaCostoActual(fechaHastaCostoActual)
                      }
                      slots={{ textField: TextField }}
                      slotProps={{
                        textField: {
                          size: "small",
                          variant: "outlined",
                          sx: { width: "100%" },
                        },
                      }}
                      disabled={tipoBusqueda !== "articulo"}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", py: 1 }}
                  >
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>

                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                    >
                      Limpiar
                    </Button>
                  </Box>
                </Grid>
              </>
            )}

            {/* tab resultados */}

            {tabIndex === 1 && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    py: 1,
                    px: 1,
                  }}
                >
                  <Typography
                    sx={{ color: "primary.main", fontWeight: "bold" }}
                    variant="body2"
                  >
                    Total de Armazones: {articulos.length} - Armazones a
                    actualizar: {selectedRows.length}
                  </Typography>

                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setOpenConfirmDialog(true)}
                    disabled={disabledAplicarCambios}
                  >
                    Aplicar cambios
                  </Button>
                </Box>

                <DataGrid
                  rows={articulos}
                  columns={tableColumns}
                  {...tableOptions}
                />
              </>
            )}

            {/* tab opciones */}

            {tabIndex === 2 && (
              <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
                {/* Costo Actual */}

                <Accordion
                  sx={{ border: "1px solid lightgray" }}
                  expanded={expandedAccordion === "costoActual"}
                  onChange={() =>
                    setExpandedAccordion(
                      expandedAccordion === "costoActual"
                        ? null
                        : "costoActual",
                    )
                  }
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ ml: 2 }} variant="subtitle2">
                      Costo Actual
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <FormControl>
                          <RadioGroup
                            name="tipo"
                            value={valoresData.tipo}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoCostoPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACCostoPorcentaje?.id
                                    ? valueACCostoPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACCostoPorcentaje(newValue);
                                }}
                                inputValue={inputValueACCostoPorcentaje}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACCostoPorcentaje(newInputValue);
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoRadioState !== "tipoCostoPorcentaje"
                                }
                              />

                              <TextField
                                id="costoPorcentajeValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Porcentaje"
                                variant="outlined"
                                name="costoPorcentajeValor"
                                type="text"
                                value={valoresData.costoPorcentajeValor}
                                onChange={handleChangeNumber}
                                inputMode="numeric"
                                disabled={
                                  tipoRadioState !== "tipoCostoPorcentaje" ||
                                  valueACCostoPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoCostoMonto"
                                control={<Radio size="small" />}
                                label="Monto en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACCostoMonto?.id
                                    ? valueACCostoMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setvalueACCostoMonto(newValue);
                                }}
                                inputValue={inputValueACCostoMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACCostoMonto(newInputValue);
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={tipoRadioState !== "tipoCostoMonto"}
                              />

                              <TextField
                                id="costoMontoValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Monto en $"
                                variant="outlined"
                                name="costoMontoValor"
                                type="text"
                                value={valoresData.costoMontoValor}
                                onChange={handleChangeNumber}
                                inputMode="numeric"
                                disabled={
                                  tipoRadioState !== "tipoCostoMonto" ||
                                  valueACCostoMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR EN PESO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoCostoFijarPeso"
                                control={<Radio size="small" />}
                                label="Fijar en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  id="costoValorFijarPeso"
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input": {
                                      textAlign: "right",
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="costoValorFijarPeso"
                                  type="text"
                                  value={valoresData.costoValorFijarPeso}
                                  onChange={handleChangeNumber}
                                  inputMode="numeric"
                                  disabled={
                                    tipoRadioState !== "tipoCostoFijarPeso"
                                  }
                                />
                              </Grid>
                            </Box>

                            {/* FIJAR EN DOLAR */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoCostoFijarDolar"
                                control={<Radio size="small" />}
                                label="Fijar en U$S"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  id="costoValorFijarDolar"
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input": {
                                      textAlign: "right",
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="costoValorFijarDolar"
                                  type="text"
                                  value={valoresData.costoValorFijarDolar}
                                  onChange={handleChangeNumber}
                                  inputMode="numeric"
                                  disabled={
                                    tipoRadioState !== "tipoCostoFijarDolar"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Factor de Utilidad */}

                <Accordion
                  sx={{ border: "1px solid lightgray" }}
                  expanded={expandedAccordion === "factorUtilidad"}
                  onChange={() =>
                    setExpandedAccordion(
                      expandedAccordion === "factorUtilidad"
                        ? null
                        : "factorUtilidad",
                    )
                  }
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ ml: 2 }} variant="subtitle2">
                      Factor de Utilidad
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <FormControl>
                          <Typography variant="h6" sx={{ mb: 1, ml: 1 }}>
                            Contado
                          </Typography>

                          <RadioGroup
                            name="tipoFactorContado"
                            value={valoresData.tipoFactorContado}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorContadoPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACFactorContadoPorcentaje?.id
                                    ? valueACFactorContadoPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACFactorContadoPorcentaje(newValue);
                                }}
                                inputValue={inputValueACFactorContadoPorcentaje}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACFactorContadoPorcentaje(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoFactorContadoRadioState !==
                                  "tipoFactorContadoPorcentaje"
                                }
                              />

                              <TextField
                                id="factorContadoPorcentajeValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Porcentaje"
                                variant="outlined"
                                name="factorContadoPorcentajeValor"
                                type="text"
                                value={valoresData.factorContadoPorcentajeValor}
                                onChange={handleChangeNumber}
                                inputMode="numeric"
                                disabled={
                                  tipoFactorContadoRadioState !==
                                  "tipoFactorContadoPorcentaje" ||
                                  valueACFactorContadoPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorContadoMonto"
                                control={<Radio size="small" />}
                                label="Valor"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACFactorContadoMonto?.id
                                    ? valueACFactorContadoMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACFactorContadoMonto(newValue);
                                }}
                                inputValue={inputValueACFactorContadoMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACFactorContadoMonto(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoFactorContadoRadioState !==
                                  "tipoFactorContadoMonto"
                                }
                              />

                              <TextField
                                id="factorContadoMontoValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Valor"
                                variant="outlined"
                                name="factorContadoMontoValor"
                                type="text"
                                value={valoresData.factorContadoMontoValor}
                                onChange={handleChangeNumber}
                                disabled={
                                  tipoFactorContadoRadioState !==
                                  "tipoFactorContadoMonto" ||
                                  valueACFactorContadoMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR VALOR */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorContadoFijarValor"
                                control={<Radio size="small" />}
                                label="Fijar en"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  id="factorContadoValorFijarPeso"
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input": {
                                      textAlign: "right",
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  label="Valor"
                                  variant="outlined"
                                  name="factorContadoValorFijarPeso"
                                  type="text"
                                  value={
                                    valoresData.factorContadoValorFijarPeso
                                  }
                                  onChange={handleChangeNumber}
                                  inputMode="numeric"
                                  disabled={
                                    tipoFactorContadoRadioState !==
                                    "tipoFactorContadoFijarValor"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl>
                          <Typography variant="h6" sx={{ mb: 1, ml: 1 }}>
                            Lista
                          </Typography>

                          <RadioGroup
                            name="tipoFactorLista"
                            value={valoresData.tipoFactorLista}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorListaPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACFactorListaPorcentaje?.id
                                    ? valueACFactorListaPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACFactorListaPorcentaje(newValue);
                                }}
                                inputValue={inputValueACFactorListaPorcentaje}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACFactorListaPorcentaje(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoFactorListaRadioState !==
                                  "tipoFactorListaPorcentaje"
                                }
                              />

                              <TextField
                                id="factorListaPorcentajeValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Porcentaje"
                                variant="outlined"
                                name="factorListaPorcentajeValor"
                                type="text"
                                value={valoresData.factorListaPorcentajeValor}
                                onChange={handleChangeNumber}
                                inputMode="numeric"
                                disabled={
                                  tipoFactorListaRadioState !==
                                  "tipoFactorListaPorcentaje" ||
                                  valueACFactorListaPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorListaMonto"
                                control={<Radio size="small" />}
                                label="Valor"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACFactorListaMonto?.id
                                    ? valueACFactorListaMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACFactorListaMonto(newValue);
                                }}
                                inputValue={inputValueACFactorListaMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACFactorListaMonto(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoFactorListaRadioState !==
                                  "tipoFactorListaMonto"
                                }
                              />

                              <TextField
                                id="factorListaMontoValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Valor"
                                variant="outlined"
                                name="factorListaMontoValor"
                                type="text"
                                value={valoresData.factorListaMontoValor}
                                onChange={handleChangeNumber}
                                inputMode="numeric"
                                disabled={
                                  tipoFactorListaRadioState !==
                                  "tipoFactorListaMonto" ||
                                  valueACFactorListaMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR VALOR */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorListaFijarValor"
                                control={<Radio size="small" />}
                                label="Fijar en"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  id="factorListaValorFijarPeso"
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input": {
                                      textAlign: "right",
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  label="Valor"
                                  variant="outlined"
                                  name="factorListaValorFijarPeso"
                                  type="text"
                                  value={valoresData.factorListaValorFijarPeso}
                                  onChange={handleChangeNumber}
                                  inputMode="numeric"
                                  disabled={
                                    tipoFactorListaRadioState !==
                                    "tipoFactorListaFijarValor"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Precio de Venta */}

                <Accordion
                  sx={{ border: "1px solid lightgray" }}
                  expanded={expandedAccordion === "precioVenta"}
                  onChange={() =>
                    setExpandedAccordion(
                      expandedAccordion === "precioVenta"
                        ? null
                        : "precioVenta",
                    )
                  }
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ ml: 2 }} variant="subtitle2">
                      Precio de Venta
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <FormControl>
                          <Typography variant="h6" sx={{ mb: 1, ml: 1 }}>
                            Contado
                          </Typography>

                          <RadioGroup
                            name="tipoPrecioVentaContado"
                            value={valoresData.tipoPrecioVentaContado}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaContadoPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACPrecioVentaContadoPorcentaje?.id
                                    ? valueACPrecioVentaContadoPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACPrecioVentaContadoPorcentaje(
                                    newValue,
                                  );
                                }}
                                inputValue={
                                  inputValueACPrecioVentaContadoPorcentaje
                                }
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACPrecioVentaContadoPorcentaje(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoPrecioVentaContadoRadioState !==
                                  "tipoPrecioVentaContadoPorcentaje"
                                }
                              />

                              <TextField
                                id="precioVentaContadoPorcentajeValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Porcentaje"
                                variant="outlined"
                                name="precioVentaContadoPorcentajeValor"
                                type="text"
                                value={
                                  valoresData.precioVentaContadoPorcentajeValor
                                }
                                onChange={handleChangeNumber}
                                inputMode="numeric"
                                disabled={
                                  tipoPrecioVentaContadoRadioState !==
                                  "tipoPrecioVentaContadoPorcentaje" ||
                                  valueACPrecioVentaContadoPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaContadoMonto"
                                control={<Radio size="small" />}
                                label="Monto en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACPrecioVentaContadoMonto?.id
                                    ? valueACPrecioVentaContadoMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACPrecioVentaContadoMonto(newValue);
                                }}
                                inputValue={inputValueACPrecioVentaContadoMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACPrecioVentaContadoMonto(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoPrecioVentaContadoRadioState !==
                                  "tipoPrecioVentaContadoMonto"
                                }
                              />

                              <TextField
                                id="precioVentaContadoMontoValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Monto en $"
                                variant="outlined"
                                name="precioVentaContadoMontoValor"
                                type="text"
                                value={valoresData.precioVentaContadoMontoValor}
                                onChange={handleChangeNumber}
                                inputMode="numeric"
                                disabled={
                                  tipoPrecioVentaContadoRadioState !==
                                  "tipoPrecioVentaContadoMonto" ||
                                  valueACPrecioVentaContadoMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR EN PESO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaContadoFijarPeso"
                                control={<Radio size="small" />}
                                label="Fijar en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  id="precioVentaContadoValorFijarPeso"
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input": {
                                      textAlign: "right",
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="precioVentaContadoValorFijarPeso"
                                  type="text"
                                  value={
                                    valoresData.precioVentaContadoValorFijarPeso
                                  }
                                  onChange={handleChangeNumber}
                                  inputMode="numeric"
                                  disabled={
                                    tipoPrecioVentaContadoRadioState !==
                                    "tipoPrecioVentaContadoFijarPeso"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl>
                          <Typography variant="h6" sx={{ mb: 1, ml: 1 }}>
                            Lista
                          </Typography>

                          <RadioGroup
                            name="tipoPrecioVentaLista"
                            value={valoresData.tipoPrecioVentaLista}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaListaPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACPrecioVentaListaPorcentaje?.id
                                    ? valueACPrecioVentaListaPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACPrecioVentaListaPorcentaje(
                                    newValue,
                                  );
                                }}
                                inputValue={
                                  inputValueACPrecioVentaListaPorcentaje
                                }
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACPrecioVentaListaPorcentaje(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoPrecioVentaListaRadioState !==
                                  "tipoPrecioVentaListaPorcentaje"
                                }
                              />

                              <TextField
                                id="precioVentaListaPorcentajeValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Porcentaje"
                                variant="outlined"
                                name="precioVentaListaPorcentajeValor"
                                type="text"
                                value={
                                  valoresData.precioVentaListaPorcentajeValor
                                }
                                onChange={handleChangeNumber}
                                inputMode="numeric"
                                disabled={
                                  tipoPrecioVentaListaRadioState !==
                                  "tipoPrecioVentaListaPorcentaje" ||
                                  valueACPrecioVentaListaPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaListaMonto"
                                control={<Radio size="small" />}
                                label="Monto en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACPrecioVentaListaMonto?.id
                                    ? valueACPrecioVentaListaMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACPrecioVentaListaMonto(newValue);
                                }}
                                inputValue={inputValueACPrecioVentaListaMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACPrecioVentaListaMonto(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoPrecioVentaListaRadioState !==
                                  "tipoPrecioVentaListaMonto"
                                }
                              />

                              <TextField
                                id="precioVentaListaMontoValor"
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input": {
                                    textAlign: "right",
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                label="Monto en $"
                                variant="outlined"
                                name="precioVentaListaMontoValor"
                                type="text"
                                value={valoresData.precioVentaListaMontoValor}
                                onChange={handleChangeNumber}
                                inputMode="numeric"
                                disabled={
                                  tipoPrecioVentaListaRadioState !==
                                  "tipoPrecioVentaListaMonto" ||
                                  valueACPrecioVentaListaMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR EN PESO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaListaFijarPeso"
                                control={<Radio size="small" />}
                                label="Fijar en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  id="precioVentaListaValorFijarPeso"
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input": {
                                      textAlign: "right",
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="precioVentaListaValorFijarPeso"
                                  type="text"
                                  value={
                                    valoresData.precioVentaListaValorFijarPeso
                                  }
                                  onChange={handleChangeNumber}
                                  inputMode="numeric"
                                  disabled={
                                    tipoPrecioVentaListaRadioState !==
                                    "tipoPrecioVentaListaFijarPeso"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Botones FUERA del Accordion */}

                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", py: 1 }}
                  >
                    <Button
                      variant="contained"
                      color="info"
                      startIcon={<CalculateIcon />}
                      onClick={handleCalcularCambios}
                    >
                      Calcular cambios
                    </Button>
                  </Box>
                </Grid>
              </Paper>
            )}
          </Box>
        </Paper>
      </Paper>

      {openDialog && (
        <ValorArmazonDialog
          onClose={handleDialogClose}
          articuloData={articuloData}
        />
      )}

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
      >
        <DialogTitle>Confirmar aplicación de cambios</DialogTitle>

        <DialogContent>
          <DialogContentText>
            ¿Confirmás que querés aplicar los cambios? Esta acción no se puede
            deshacer
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmDialog(false);
              aplicarCambios();
            }}
            color="primary"
            variant="contained"
            sx={{
              mt: 1,
              mb: 1,
            }}
          >
            Confirmar
          </Button>

          <Button
            onClick={() => setOpenConfirmDialog(false)}
            variant="outlined"
            sx={{
              mr: 2,
              mt: 1,
              mb: 1,
            }}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ValorArmazonTable;